import { render } from "./TopList.vue?vue&type=template&id=5290c338"
import script from "./TopList.vue?vue&type=script&lang=js"
export * from "./TopList.vue?vue&type=script&lang=js"
script.render = render

export default script